export default __webpack_public_path__ + "static/media/claimCardBg.a9b5c654.svg";